<div class="weekly-card" [class.complete]="weekCompletions.length >= target">
  <button type="button" class="weekly-toggle"
          (click)="doToggle()"
          [attr.aria-label]="'Log one completion'">
    <span class="toggle-symbol">+</span>
  </button>

  <div class="weekly-body">
    <div class="weekly-header">
      <span class="weekly-name">{{ habit.name }}</span>
      <span *ngIf="habit.category" class="weekly-tag">{{ habit.category }}</span>
      <span class="weekly-progress-text">{{ weekCompletions.length }} / {{ target }}</span>
      <button type="button" class="weekly-edit-btn" (click)="doEdit($event)" aria-label="Edit habit">✎</button>
    </div>

    <div class="weekly-progress-bar">
      <div class="weekly-progress-fill" [style.width.%]="progressPercent"></div>
    </div>

    <div *ngIf="weekCompletions.length" class="weekly-days">
      <span *ngFor="let c of weekCompletions" class="weekly-day-pill">
        ✓ {{ weekdayLabel(c.date) }}
        <button type="button" class="day-note-btn" (click)="expandNote(c.id)">
          <span *ngIf="!draftNoteFor[c.id]?.trim()">+ note</span>
          <span *ngIf="draftNoteFor[c.id]?.trim()">📝</span>
        </button>
        <button type="button" class="day-remove-btn"
                (click)="doRemove(c.id)"
                [attr.aria-label]="'Remove ' + weekdayLabel(c.date) + ' completion'">✕</button>
      </span>
    </div>

    <ng-container *ngFor="let c of weekCompletions">
      <textarea *ngIf="isExpanded(c.id)"
                class="weekly-note"
                [attr.placeholder]="'Notes for ' + weekdayLabel(c.date)"
                [value]="draftNoteFor[c.id] || ''"
                (input)="onNoteInput(c.id, $any($event.target).value)"
                (blur)="onNoteBlur(c.id)"
                rows="2"></textarea>
    </ng-container>
  </div>
</div>
